module.exports = __webpack_public_path__ + "static/media/vg.7dc61c20.svg";